import { fetchFactory } from 'isotope-client'

export const createAction = (form) => fetchFactory('/actions/create', { body: JSON.stringify(form), method: 'post' }, '/api')
export const updateAction = (form) => fetchFactory('/actions/update', { body: JSON.stringify(form), method: 'post' }, '/api')
export const closeAction = (id) => fetchFactory(`/actions/close?id=${id}`, {}, '/api')
export const getOverdueActions = () => fetchFactory('/actions/overdue', {}, '/api')